import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { X } from "lucide-react";

export const ALL = "tutti";
export const EMPTY_FILTERS = { fabric_type: ALL, color: ALL, supplier: ALL };
const FIELDS = [["fabric_type", "Tipologia", "Tutte le tipologie"], ["color", "Colore", "Tutti i colori"], ["supplier", "Fornitore", "Tutti i fornitori"]];

const uniq = (materials, k) => [...new Set(materials.map((m) => m[k]).filter(Boolean))].sort((a, b) => a.localeCompare(b));

export const matchesFilters = (m, f) => FIELDS.every(([k]) => f[k] === ALL || m[k] === f[k]);

export const FabricFilters = ({ materials, filters, onChange }) => {
  const active = FIELDS.some(([k]) => filters[k] !== ALL);
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2" data-testid="fabric-filters">
      {FIELDS.map(([k, label, all]) => (
        <Select key={k} value={filters[k]} onValueChange={(v) => onChange({ ...filters, [k]: v })}>
          <SelectTrigger className="h-9 w-48" aria-label={label} data-testid={`fabric-filter-${k}`}><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-72">
            <SelectItem value={ALL}>{all}</SelectItem>
            {uniq(materials, k).map((v) => <SelectItem key={v} value={v}>{v}</SelectItem>)}
          </SelectContent>
        </Select>
      ))}
      {active && <Button variant="ghost" size="sm" onClick={() => onChange(EMPTY_FILTERS)} data-testid="fabric-filters-reset"><X className="mr-1 h-4 w-4" />Azzera filtri</Button>}
    </div>
  );
};
